import { render, staticRenderFns } from "./TipoPedidoManage.vue?vue&type=template&id=06224029&scoped=true"
import script from "./TipoPedidoManage.vue?vue&type=script&lang=js"
export * from "./TipoPedidoManage.vue?vue&type=script&lang=js"
import style0 from "./TipoPedidoManage.vue?vue&type=style&index=0&id=06224029&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06224029",
  null
  
)

export default component.exports